import logEvent from '../../logEvent';

function logEventAssistedOnboarding(code, data, isAddPlan = false) {
  if (isAddPlan) {
    logEvent(`UFAP-${code}`, data);
  } else {
    logEvent(`UFOB-${code}`, data);
  }
}

export function logEventAssistedOnboardingSubscriberDetails(data) {
  logEventAssistedOnboarding('01', data);
}

export function logEventAssistedOnboardingEmailVerification(data) {
  logEventAssistedOnboarding('02', data);
}

export function logEventAssistedOnboardingInPersonORWebAppointment() {
  logEventAssistedOnboarding('03');
}

export function logEventAssistedOnboardingIDV() {
  logEventAssistedOnboarding('04');
}

export function logEventAssistedOnboardingIDVSuccessful(verificationJob) {
  const { id } = verificationJob || {};
  logEventAssistedOnboarding('05', { jobId: id });
}

export function logEventAssistedOnboardingIDVManual() {
  logEventAssistedOnboarding('06');
}

export function logEventAssistedOnboardingPlanType(isAddPlan = false) {
  const codeNumber = isAddPlan ? '01' : '07';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingTransferPlan(isAddPlan = false) {
  const codeNumber = isAddPlan ? '02' : '08';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingChecklist(data, isAddPlan = false) {
  const codeNumber = isAddPlan ? '03' : '09';
  logEventAssistedOnboarding(codeNumber, data, isAddPlan);
}

export function logEventAssistedOnboardingOpeningRESP(isAddPlan = false) {
  const codeNumber = isAddPlan ? '04' : '10';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingSubscriberSin() {
  logEventAssistedOnboarding('11');
}

export function logEventAssistedOnboardingEmploymentStatus() {
  logEventAssistedOnboarding('12');
}

export function logEventAssistedOnboardingCivilStatus() {
  logEventAssistedOnboarding('13');
}

export function logEventAssistedOnboardingGrossIncome() {
  logEventAssistedOnboarding('14');
}

export function logEventAssistedOnboardingAssetsLiabilities() {
  logEventAssistedOnboarding('15');
}

export function logEventAssistedOnboardingADependents() {
  logEventAssistedOnboarding('16');
}

export function logEventAssistedOnboardingInvestingExperience() {
  logEventAssistedOnboarding('17');
}

export function logEventAssistedOnboardingIps1(isAddPlan = false) {
  const codeNumber = isAddPlan ? '05' : '18';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps2(isAddPlan = false) {
  const codeNumber = isAddPlan ? '06' : '19';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps3(isAddPlan = false) {
  const codeNumber = isAddPlan ? '07' : '20';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps4(isAddPlan = false) {
  const codeNumber = isAddPlan ? '08' : '21';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps5(isAddPlan = false) {
  const codeNumber = isAddPlan ? '09' : '22';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps6(isAddPlan = false) {
  const codeNumber = isAddPlan ? '10' : '23';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps7(isAddPlan = false) {
  const codeNumber = isAddPlan ? '11' : '24';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingIps8(isAddPlan = false) {
  const codeNumber = isAddPlan ? '12' : '25';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventAssistedOnboardingRiskProfile(data, isAddPlan = false) {
  const codeNumber = isAddPlan ? '13' : '26';
  logEventAssistedOnboarding(codeNumber, data, isAddPlan);
}

export function logEventAssistedOnboardingChildProfileStart(data, isAddPlan = false) {
  const codeNumber = isAddPlan ? '14' : '27';
  logEventAssistedOnboarding(codeNumber, data, isAddPlan);
}

export function logEventAssistedOnboardingChildDetails(data, isAddPlan = false) {
  const codeNumber = isAddPlan ? '15' : '28';
  logEventAssistedOnboarding(codeNumber, data, isAddPlan);
}

export function logEventAssistedOnboardingChildSin(data, isAddPlan = false) {
  const codeNumber = isAddPlan ? '16' : '29';
  logEventAssistedOnboarding(codeNumber, data, isAddPlan);
}

export function logEventAssistedOnboardingApplicationReview(data, isAddPlan = false) {
  const codeNumber = isAddPlan ? '17' : '30';
  logEventAssistedOnboarding(codeNumber, data, isAddPlan);
}

export function logEventAssistedOnboardingSuccess(isAddPlan = false) {
  const codeNumber = isAddPlan ? '18' : '31';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}

export function logEventOnboardingCoSubButtonClick(isAddPlan = false) {
  const codeNumber = isAddPlan ? '19' : '32';
  logEventAssistedOnboarding(codeNumber, null, isAddPlan);
}
